import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import ToolbarTool from '../../commonComponents/ToolbarTool';
import Icon from '../../../../components/icons/Icon';

// Utils
import { isSelectingMultipleSelections } from '../../../../element/table/utils/tableCellSelectionUtils';

// Selectors
import { getCurrentCellSelections } from '../../../../element/table/tableSelector';
import { getElementId } from '../../../../../common/elements/utils/elementPropertyUtils';
import HotTableManager from '../../../../element/table/manager/HotTableManager';

const mapStateToProps = createStructuredSelector({
    currentCellSelections: getCurrentCellSelections,
});

const AddColumnTool = (props) => {
    const { element, currentCellSelections } = props;

    const elementId = getElementId(element);

    const updateAddColumn = () => {
        const hotTable = HotTableManager?.getHotTableComponent(elementId);
        if (!hotTable?.tableOperationsRef?.current) return;

        hotTable.tableOperationsRef.current.addColsRight();
    };

    return (
        <div className="AddColumnTool">
            <ToolbarTool
                {...props}
                onPointerDown={updateAddColumn}
                name="Add column"
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                tooltipText={'Add column'}
                shortcut={['alt', '→']}
            >
                <Icon name="toolbar-add-column" />
            </ToolbarTool>
        </div>
    );
};

AddColumnTool.propTypes = {
    iconName: PropTypes.string,
    element: PropTypes.object,
    currentCellSelections: PropTypes.object,
};

export default connect(mapStateToProps)(AddColumnTool);
